import { BasicOwnerConfig } from './basic-owner-config';
import { LicenseTypeKind, MenuSection } from './const/enum';
import { License } from './license';
import { MenuDef, SidebarItemDefinition } from './sidebar-item';

export const Features = {
  AccountingExport: 'AccountingExport',
  AccountPlan: 'AccountPlan',
  Admin: 'Admin',
  AttestInvoices: 'AttestInvoices',
  Consumption_Pricelist_Read: 'Consumption_Pricelist_Read',
  Consumption_Pricelist_Create: 'Consumption_Pricelist_Create',
  Consumption_Pricelist_Update: 'Consumption_Pricelist_Update',
  Consumption_Pricelist_Delete: 'Consumption_Pricelist_Delete',
  Consumption_MeterModel_Read: 'Consumption_MeterModel_Read',
  Consumption_MeterModel_Create: 'Consumption_MeterModel_Create',
  Consumption_MeterModel_Update: 'Consumption_MeterModel_Update',
  Consumption_MeterModel_Delete: 'Consumption_MeterModel_Delete',
  CooperatvieHousing_ControlData: 'CooperatvieHousing_ControlData',
  CooperatvieHousing_Transfers: 'CooperatvieHousing_Transfers',
  CooperativeHousing_BrfMortgagePrescription: 'CooperativeHousing_BrfMortgagePrescription',
  CreditInvoices: 'CreditInvoices',
  Letting_DhMarket: 'LettingDhMarket',
  Letting_HomeQ: 'LettingHomeQ',
  Letting_BoplatsSverige: 'LettingBoplatsSverige',
  ManageEmail: 'ManageEmail',
  ManageESignatures: 'ManageESignatures',
  ManageFaultNotifications: 'ManageFaultNotifications',
  ManageGenericErrands: 'ManageGenericErrands',
  ManageErrandTags: 'ManageErrandTags',
  ManageAuthorityInspection: 'ManageAuthorityInspection',
  ManageAuthorityInspectionErrands: 'ManageAuthorityInspectionErrands',
  ManageDwellingInspectionErrands: 'ManageDwellingInspectionErrands',
  ManageCooperativeHousingAgreements: 'ManageCooperativeHousingAgreements',
  ShowCooperativeHousingAgreements: 'ShowCooperativeHousingAgreements',
  ManageRoundingErrands: 'ManageRoundingErrands',
  ManageDebtCollection: 'ManageDebtCollection',
  ManageIncorrectPayments: 'ManageIncorrectPayments',
  ManageInvoices: 'ManageInvoices',
  ShowInvoices: 'ShowInvoices',
  ShowPrintOrders: 'ShowPrintOrders',
  ShowIncorrectPayments: 'ShowIncorrectPayments',
  ShowBankTransactionImports: 'ShowBankTransactionImports',
  ShowContactBalanceTransactions: 'ShowContactBalanceTransactions',
  ShowInvoiceReminders: 'ShowInvoiceReminders',
  ShowAmortizationPlans: 'ShowAmortizationPlans',
  ShowAmortizationPlanPaymentNotices: 'ShowAmortizationPlanPaymentNotices',
  ShowDebtCollectionCases: 'ShowDebtCollectionCases',
  ShowInvoiceRowGroups: 'ShowInvoiceRowGroups',
  ManageLeaseAgreements: 'ManageLeaseAgreements',
  ShowLeaseAgreements: 'ShowLeaseAgreements',
  ManageMail: 'ManageMail',
  ManageOwnAuthorityInspectionErrands: 'ManageOwnAuthorityInspectionErrands',
  ManageOwnDwellingInspectionErrands: 'ManageOwnDwellingInspectionErrands',
  ManageOwnFaultNotifications: 'ManageOwnFaultNotifications',
  ManageOwnGenericErrands: 'ManageOwnGenericErrands',
  ManageOwnRoundingErrands: 'ManageOwnRoundingErrands',
  ManageOwnTenantRequestErrands: 'ManageOwnTenantRequestErrands',
  ManageOwnWorkOrders: 'ManageOwnWorkOrders',
  ManageRentArticles: 'ManageRentArticles',
  ManageRentLoss: 'ManageRentLoss',
  ManageNominalLedger: 'ManageNominalLedger',
  ViewOpeningBalance: 'ViewOpeningBalance',
  ManageOpeningBalance: 'ManageOpeningBalance',
  CloseAccountingPeriod: 'CloseAccountingPeriod',
  ReopenAccountingPeriod: 'ReopenAccountingPeriod',
  ManageResources: 'ManageResources',
  ManageSms: 'ManageSms',
  ManageTenantPagesInformation: 'ManageTenantPagesInformation',
  ManageTenantRequestErrands: 'ManageTenantRequestErrands',
  ManageWorkOrders: 'ManageWorkOrders',
  NominalLedger: 'NominalLedger',
  Overview: 'Overview',
  RentInvoicing: 'RentInvoicing',
  GrantDeferment: 'GrantDeferment',
  SendForDebtCollection: 'SendForDebtCollection',
  ShowPayments: 'ShowPayments',
  ShowRoundPlannings: 'ShowRoundPlannings',
  ShowChecklists: 'ShowChecklist',
  ManagePricelists: 'ManagePricelists',
  ShowContact: 'ShowContact',
  EditContact: 'EditContact',
  InvoiceRowGroup: 'InvoiceRowGroup',
  TenantList: 'TenantList',
  ShowCompany: 'ShowCompany',
  EditCompany: 'EditCompany',
  ShowProperty: 'ShowProperty',
  EditProperty: 'EditProperty',
  ShowBuilding: 'ShowBuilding',
  EditBuilding: 'EditBuilding',
  ShowDwelling: 'ShowDwelling',
  EditDwelling: 'EditDwelling',
  ShowPremises: 'ShowPremises',
  EditPremises: 'EditPremises',
  ShowParking: 'ShowParking',
  EditParking: 'EditParking',
  ShowOtherRentalObject: 'ShowOtherRentalObject',
  EditOtherRentalObject: 'EditOtherRentalObject',
  ShowRentalObjectKeys: 'ShowRentalObjectKeys',
  EditRentalObjectKeys: 'EditRentalObjectKeys',
  EditLettingFeatures: 'EditLettingFeatures',
  LinkPropertyBaseDocuments: 'LinkPropertyBaseDocuments',
  ChangeRentalObjectCategory: 'ChangeRentalObjectCategory',
  LinkContactDocuments: 'LinkContactDocuments',
  ShowReportPropertyOverview: 'ShowReportPropertyOverview',
  ShowReportReasonablenessControl: 'ShowReportReasonablenessControl',
  ShowReportRentalObjectRentLoss: 'ShowReportRentalObjectRentLoss',
  ShowReportMonthAnalysisAmount: 'ShowReportMonthAnalysisAmount',
  ShowReportAccountBalancePerInvoice: 'ShowReportAccountBalancePerInvoice',
  ShowReportRentRoll: 'ShowReportRentRoll',
  ShowReportNotFullyPaidInvoice: 'ShowReportNotFullyPaidInvoice',
  ShowReportVatReport: 'ShowReportVatReport',
  ShowReportVoluntaryTaxLiability: 'ShowReportVoluntaryTaxLiability',
  ShowReportInvoicedPerRentalObject: 'ShowReportInvoicedPerRentalObject',
  ShowReportStaircase: 'ShowReportStaircase',
  ShowReportTaxReduction: 'ShowReportTaxReduction',
  ShowReportMembershipList: 'ShowReportMembershipList',
  Admin_ProtectedIdentity: 'Admin_ProtectedIdentity',
  ShowReportBrfInnerFundPerRentalObject: 'ShowReportBrfInnerFundPerRentalObject',
  ShowReportCheckInAndCheckOutList: 'ShowReportCheckInAndCheckOutList',
};

export const ModuleNames = {
  Accounting: 'Accounting',
  Consumption: 'Consumption',
  CooperativeHousing: 'CooperativeHousing',
  DwellingInspection: 'DwellingInspection',
  Errands: 'Errands', // <-- FIXME: The definition of "errand" has changed over time.... this is misaligned!
  Invoicing: 'Invoicing',
  Landlords: 'Landlords',
  Letting: 'Letting',
  Messages: 'Messages',
  Mortgage: 'Mortgage',
  Properties: 'Properties',
  Rent: 'Rent',
  Reports: 'Reports',
  System: 'System',
  RoundPlanning: 'RoundPlanning',
  AuthorityInspection: 'AuthorityInspection',
  Common: 'Common',
  ProtectedIdentity: 'ProtectedIdentity',
};

export const LicenseRequiredModules = {
  [ModuleNames.RoundPlanning]: LicenseTypeKind.ExtendedTechnicalManagementRounding,
  [ModuleNames.AuthorityInspection]: LicenseTypeKind.ExtendedTechnicalManagementAuthorityInspection,
};

export const AccountRoutes = {
  blockContracts: 'block/contracts',
  cooperativeHousingContracts: 'co-housing/contracts',
  dwellingContracts: 'dwelling/contracts',
  otherContracts: 'other-rental-object/contracts',
  parkingContracts: 'parking/contracts',
  premisesContracts: 'premises/contracts',
  faultNotifications: 'fault-notification/notifications',
  incorrectPayments: 'incorrect-payments',
  invoices: 'invoices',
  bankTransactionImports: 'unhandled-bank-transactions',
};

export class AccountDefinition {
  constructor(
    def: any,
    private profileSettings: BasicOwnerConfig
  ) {
    if (!def) throw new Error('Invalid account definition');

    this.id = def.id;
    this.systemOwnerId = def.systemOwnerId;
    this.homeUrl = '';
    const dhPath = 'dh';
    this.email = def.email;
    this.personName = def.personName;
    this.civicNumber = def.civicNumber;
    this.phoneNumber = def.phoneNumber;
    this.menu = [{ caption: 'CHANGE_PASSWORD_BTN', href: '/' + dhPath + '/change-password' }];
    this.modules = Array.isArray(def.modules) ? def.modules : [];
    this.name = def.name;
    this.features = Array.isArray(def.features) ? def.features : [];
    this.timeoutInMinutes = def.timeoutInMinutes;
    this.licenses = Array.isArray(def.licenses) ? def.licenses : [];

    if (this.hasAccess(ModuleNames.System, Features.Admin))
      this.menu = [
        { caption: 'USER_SETTINGS_BTN', href: '/' + dhPath + '/settings' },
        { caption: 'USERS_BTN', href: '/' + dhPath + '/users' },
        { caption: 'USERGROUPS_BTN', href: '/' + dhPath + '/user-groups' },
        { caption: 'LOCATION_ACCESS.GROUP_LIST_HEADER', href: '/' + dhPath + '/location-access-groups' },
        { caption: 'USER_INFORMATION_BTN', href: '/' + dhPath + '/profile' },
        { caption: 'CHANGE_PASSWORD_BTN', href: '/' + dhPath + '/change-password' },
      ];

    if (this.modules.includes(ModuleNames.Landlords)) {
      this.homeUrl = `${this.homeUrl}/dh/landlords`;

      this.sidebar = [
        new SidebarItemDefinition('DASHBOARD.LANDLORD_ITEM_HEADER', '/dh/landlords', 'dashboard-i', MenuSection.Base),
        new SidebarItemDefinition(
          'DASHBOARD.CUSTOMER_SUPPORT_ITEM_HEADER',
          '/dh/landlords/customer-support',
          'dashboard-i',
          MenuSection.Base
        ),
        // new SidebarItemDefinition('DASHBOARD.EXPORT_ITEM_HEADER', 'export', 'dashboard-i')
      ];
    } else {
      this.sidebar = this._createLandlordSidebar();
      const firstSidebarItem = this.sidebar[0];
      this.homeUrl = firstSidebarItem
        ? `/${firstSidebarItem.hasMenu ? `${dhPath}/${firstSidebarItem.menuDefinition[0].href}` : firstSidebarItem.href}`
        : `/${dhPath}/change-password`;
    }
  }

  timeoutInMinutes: number;

  /**
   * This is specifically for the NEW "Errands" menu item!
   * Not to be confused with the OLD Errands-module (which is FaultNotifications etc).
   */
  hasNewErrandsAccess(): false | {
    hasRounding: boolean;
    hasAuthInsp: boolean;
    hasDwellingInsp: boolean;
    hasTenantRequest: boolean;
    hasGeneric: boolean;
  } {
    const hasRounding =
      this.hasAccess(ModuleNames.RoundPlanning, Features.ManageRoundingErrands) ||
      this.hasAccess(ModuleNames.RoundPlanning, Features.ManageOwnRoundingErrands);

    const hasAuthInsp =
      this.hasAccess(ModuleNames.AuthorityInspection, Features.ManageAuthorityInspectionErrands) ||
      this.hasAccess(ModuleNames.AuthorityInspection, Features.ManageOwnAuthorityInspectionErrands);

    const hasDwellingInsp =
      this.hasAccess(ModuleNames.DwellingInspection, Features.Admin) ||
      this.hasAccess(ModuleNames.DwellingInspection, Features.ManageDwellingInspectionErrands) ||
      this.hasAccess(ModuleNames.DwellingInspection, Features.ManageOwnDwellingInspectionErrands);

    const hasTenantRequestLicense =
      this.hasActiveLicense(LicenseTypeKind.ExtendedTechnicalManagementTenantErrands) || this.features.includes('Admin');
    const hasTenantRequest =
      hasTenantRequestLicense &&
      (this.hasAccess(ModuleNames.Errands, Features.ManageTenantRequestErrands) ||
        this.hasAccess(ModuleNames.Errands, Features.ManageOwnTenantRequestErrands) ||
        this.features.includes('Admin_Errands') ||
        this.features.includes('Admin'));

    const hasGeneric =
      (this.hasAccess(ModuleNames.Errands, Features.ManageGenericErrands) ||
        this.hasAccess(ModuleNames.Errands, Features.ManageOwnGenericErrands) ||
        this.features.includes('Admin_Errands') ||
        this.features.includes('Admin'));

    return hasRounding || hasAuthInsp || hasDwellingInsp || hasTenantRequest || hasGeneric
      ? { hasRounding, hasAuthInsp, hasDwellingInsp, hasTenantRequest, hasGeneric }
      : false;
  }

  hasLeaseAgreementWriteAccess(): boolean {
    const hasWriteAccess = this.hasAdminAccess(ModuleNames.Rent) || this.hasAccess(ModuleNames.Rent, Features.ManageLeaseAgreements);

    return hasWriteAccess;
  }

  hasKeyReceiptWriteAccess(): boolean {
    return (
      this.hasLeaseAgreementWriteAccess() ||
      this.hasCooperativeAgreementWriteAccess() ||
      this.hasAdminAccess(ModuleNames.Properties) ||
      this.hasAccess(ModuleNames.Properties, Features.EditRentalObjectKeys)
    );
  }

  hasCooperativeAgreementWriteAccess(): boolean {
    const hasWriteAccess =
      this.hasAdminAccess(ModuleNames.CooperativeHousing) ||
      this.hasAccess(ModuleNames.CooperativeHousing, Features.ManageCooperativeHousingAgreements);

    return hasWriteAccess;
  }

  hasContactWriteAccess(): boolean {
    const hasWriteAccess =
      this.hasAdminAccess(ModuleNames.Rent) ||
      this.hasAccess(ModuleNames.Rent, Features.ManageLeaseAgreements) ||
      this.hasAccess(ModuleNames.Common, Features.EditContact);
    return hasWriteAccess;
  }

  hasProtectedIdentityAccess(): boolean {
    return this.profileSettings.protectedIdentityEnabled && this.features.includes(Features.Admin_ProtectedIdentity);
  }

  hasLicense(licenseType: LicenseTypeKind): boolean {
    return this.licenses.some(x => x.licenseType === licenseType);
  }

  hasActiveLicense(licenseType: LicenseTypeKind): boolean {
    const now = Date.now();
    return this.licenses.some(
      license => license.licenseType === licenseType && (!license.validTo || new Date(license.validTo).getTime() >= now)
    );
  }

  hasAccess(module: string, feature?: string): boolean {
    if (module in LicenseRequiredModules) {
      if (!this.hasLicense(LicenseRequiredModules[module])) {
        return false;
      }

      // If there's a license, but specific feature is specified to check - continue.
      if (!feature) {
        return true;
      }
    }

    if (!this.isFeatureEnabled(feature)) return false;

    if (this.hasAdminAccess(module)) return true;

    return !feature ? this.modules.includes(module) : this.features.includes(feature);
  }

  /** Does NOT check license! */
  private hasAdminAccess(module: string): boolean {
    return this.features.includes('Admin_' + module) || this.features.includes('Admin');
  }

  private isFeatureEnabled(feature: string): boolean {
    if (!feature) return true;

    switch (feature) {
      case Features.ManageESignatures:
        return this.profileSettings.enableESignature;
      case Features.Letting_DhMarket:
        return this.profileSettings.useDhMarket;
      case Features.Letting_HomeQ:
        return this.profileSettings.useHomeQ;
      case Features.Letting_BoplatsSverige:
        return this.profileSettings.useBoplatsSverige;
      default:
        return true;
    }
  }

  readonly id: string;
  readonly systemOwnerId: string;
  readonly email: string;
  readonly personName: string;
  readonly homeUrl: string;
  readonly menu: MenuDef[];
  readonly modules: string[];
  readonly name: string;
  readonly civicNumber: string;
  readonly phoneNumber: string;
  readonly features: string[];
  readonly sidebar: SidebarItemDefinition[];
  readonly licenses: License[];

  private _applyMenuItemWithSubmenuCheck(itemDefinition: SidebarItemDefinition, resultArray: SidebarItemDefinition[]): void {
    if (itemDefinition.menuDefinition?.length > 0) resultArray.push(itemDefinition);
  }

  private _createLandlordSidebar(): SidebarItemDefinition[] {
    let menuItems: SidebarItemDefinition[] = [];

    if (this.hasAccess(ModuleNames.System, Features.Overview))
      menuItems.push(new SidebarItemDefinition('DASHBOARD.OVERVIEW_ITEM_HEADER', '/dh', 'dashboard-i', MenuSection.Base));

    this._applyMenuItemWithSubmenuCheck(this._getContractMenuDefinition(), menuItems);

    if (this.profileSettings.useBrf && this.hasAccess(ModuleNames.CooperativeHousing))
      this._applyMenuItemWithSubmenuCheck(this._getCooperativeHousingMenuDefinition(), menuItems);

    if (
      this.hasAccess(ModuleNames.Errands, Features.ManageFaultNotifications) ||
      this.hasAccess(ModuleNames.Errands, Features.ManageOwnFaultNotifications)
    )
      menuItems.push(
        new SidebarItemDefinition(
          'DASHBOARD.FAULT_NOTIFICATION_ITEM_HEADER',
          '/dh/fault-notification/notifications',
          'fault-notifications-i',
          MenuSection.TechnicalManagement
        )
      );

    if (this.hasNewErrandsAccess()) {
      menuItems.push(new SidebarItemDefinition('DASHBOARD.MENU.ERRANDS', '/dh/errands', 'errands-i', MenuSection.TechnicalManagement));
    }

    if (this.hasActiveLicense(LicenseTypeKind.DailyOperations)) {
      menuItems.push(
        new SidebarItemDefinition(
          'DASHBOARD.MENU.DAILY_OPERATIONS',
          '/dh/daily-operations',
          'daily-operations-i',
          MenuSection.TechnicalManagement
        )
      );
    }

    // if (this.hasAccess(ModuleNames.Errands))
    //   this._applyMenuItemWithSubmenuCheck(this._getFaultNotificationMenuDefinition(), menuItems);

    if (this.hasAccess(ModuleNames.DwellingInspection))
      this._applyMenuItemWithSubmenuCheck(this._getDwellingInspectionMenuDefinition(), menuItems);

    if (this.hasAccess(ModuleNames.RoundPlanning)) this._applyMenuItemWithSubmenuCheck(this._getRoundplanningMenuDefinition(), menuItems);

    if (this.hasAccess(ModuleNames.AuthorityInspection))
      this._applyMenuItemWithSubmenuCheck(this._getAuthorityInspectionMenuDefinition(), menuItems);

    if (this.hasAccess(ModuleNames.Errands, Features.ManageFaultNotifications) || this.hasAccess(ModuleNames.Errands, Features.TenantList))
      menuItems.push(
        new SidebarItemDefinition(
          'DASHBOARD.MENU.TENANT_LIST',
          '/dh/fault-notification/tenantlist',
          'tenants-i',
          MenuSection.TechnicalManagement
        )
      );

    if (this.hasAccess(ModuleNames.Invoicing)) this._applyMenuItemWithSubmenuCheck(this._getInvoicingMenuDefinition(), menuItems);

    if (
      this.hasAccess(ModuleNames.Rent, Features.ManageLeaseAgreements) ||
      this.hasAccess(ModuleNames.Common, Features.EditContact) ||
      this.hasAccess(ModuleNames.Common, Features.ShowContact)
    )
      menuItems.push(new SidebarItemDefinition('DASHBOARD.MENU.TENANTS', '/dh/tenants', 'tenants-i', MenuSection.Base));

    if (this.hasAccess(ModuleNames.Messages)) this._applyMenuItemWithSubmenuCheck(this._getMessagesMenuDefinition(), menuItems);

    if (this.hasAccess(ModuleNames.Mortgage) && this.profileSettings.useMortgage)
      this._applyMenuItemWithSubmenuCheck(this._getMortgageMenuDefinition(), menuItems);

    if (this.hasAccess(ModuleNames.Accounting)) this._applyMenuItemWithSubmenuCheck(this._getAccountingMenuDefinition(), menuItems);

    this._applyMenuItemWithSubmenuCheck(this._getCommonMenuDefinition(), menuItems);
    this._applyMenuItemWithSubmenuCheck(this._getSettingsMenuDefinition(), menuItems);

    if (this.hasAccess(ModuleNames.Properties)) this._applyMenuItemWithSubmenuCheck(this._getPropertiesMenuDefinition(), menuItems);

    if (this.hasAccess(ModuleNames.Reports)) this._applyMenuItemWithSubmenuCheck(this._getReportMenuDefinition(), menuItems);

    if (this.hasAccess(ModuleNames.Consumption)) this._applyMenuItemWithSubmenuCheck(this._getImdMenuDefinition(), menuItems);

    return menuItems;
  }

  private _getCooperativeHousingMenuDefinition() {
    let menuItems: MenuDef[] = [];

    if (this.profileSettings.useBrf && this.hasAccess(ModuleNames.CooperativeHousing)) {
      if (
        this.hasAccess(ModuleNames.CooperativeHousing, Features.ManageCooperativeHousingAgreements) ||
        this.hasAccess(ModuleNames.CooperativeHousing, Features.ShowCooperativeHousingAgreements)
      )
        menuItems.push({ caption: 'DASHBOARD.MENU.LEASE_AGREEMENT_COOPERATIVE_HOUSING', href: 'co-housing/contracts' });
      if (this.hasAccess(ModuleNames.CooperativeHousing, Features.CooperatvieHousing_Transfers))
        menuItems.push({ caption: 'DASHBOARD.MENU.LEASE_AGREEMENT_COOPERATIVE_HOUSING_TRANSFER', href: 'brf-transfers' });
      if (this.hasAccess(ModuleNames.CooperativeHousing, Features.CooperativeHousing_BrfMortgagePrescription))
        menuItems.push({ caption: 'DASHBOARD.MENU.MORTGAGE_PRESCRIPTIONS', href: 'brf-mortgage_prescriptions' });
      if (this.hasAccess(ModuleNames.CooperativeHousing, Features.CooperatvieHousing_ControlData))
        menuItems.push({ caption: 'DASHBOARD.MENU.CONTROL_DATA_EXPORT', href: 'cd-export' });
    }

    return new SidebarItemDefinition(
      'DASHBOARD.MENU.COOPERATIVE_HOUSING',
      '',
      'rental-objects-i',
      MenuSection.EconomicManagement,
      menuItems
    );
  }

  private _getCommonMenuDefinition() {
    let menuItems: MenuDef[] = [];
    const dhPath = 'dh';

    if (this.hasAccess(ModuleNames.Common, Features.ManageRentArticles))
      menuItems.push({ caption: 'DASHBOARD.MENU.ARTICLE', href: 'articles' });

    if (this.hasAccess(ModuleNames.Common, Features.ManageRentArticles))
      menuItems.push({ caption: 'DASHBOARD.MENU.ARTICLE_GROUPS', href: 'article-groups' });

    if (this.hasAccess(ModuleNames.Common, Features.ManagePricelists))
      menuItems.push({ caption: 'DASHBOARD.MENU.PRICELISTS', href: 'pricelists' });

    if (this.hasAccess(ModuleNames.System, Features.Admin))
      menuItems.push({ caption: 'USER_SETTINGS_BTN', href: '/' + dhPath + '/settings' });

    if (this.hasAdminAccess(ModuleNames.Errands) || this.hasAccess(ModuleNames.Errands, Features.ManageErrandTags))
      menuItems.push({ caption: 'DASHBOARD.MENU.ERRAND_TAG', href: 'standalone-errands/access-restrictions' });

    if (this.hasAccess(ModuleNames.System, Features.Admin))
      menuItems.push(
        ...[
          { caption: 'USERS_BTN', href: '/' + dhPath + '/users' },
          { caption: 'USERGROUPS_BTN', href: '/' + dhPath + '/user-groups' },
          { caption: 'LOCATION_ACCESS.GROUP_LIST_HEADER', href: '/' + dhPath + '/location-access-groups' },
          { caption: 'USER_INFORMATION_BTN', href: '/' + dhPath + '/profile' },
        ]
      );

    return new SidebarItemDefinition('DASHBOARD.MENU.COMMON', '', 'gears-i', MenuSection.Other, menuItems);
  }

  private _getAccountingMenuDefinition() {
    let menuItems: MenuDef[] = [];
    if (this.hasAccess(ModuleNames.Accounting, Features.AccountPlan))
      menuItems.push({ caption: 'DASHBOARD.MENU.ACCOUNT_PLAN', href: 'accounting/account-plan' });

    if (
      this.hasAccess(ModuleNames.Accounting, Features.NominalLedger) ||
      this.hasAccess(ModuleNames.Accounting, Features.ManageNominalLedger)
    )
      menuItems.push({ caption: 'DASHBOARD.MENU.NOMINAL_LEDGER', href: 'accounting/nominal-ledger' });

    if (this.hasAccess(ModuleNames.Accounting, Features.AccountingExport))
      menuItems.push({ caption: 'DASHBOARD.MENU.ACCOUNT_EXPORT', href: 'accounting/export' });

    if (
      this.hasAccess(ModuleNames.Accounting, Features.ViewOpeningBalance) ||
      this.hasAccess(ModuleNames.Accounting, Features.ManageOpeningBalance)
    )
      menuItems.push({ caption: 'DASHBOARD.MENU.OPENING_BALANCE', href: 'accounting/opening-balance' });

    if (this.hasAccess(ModuleNames.Accounting, Features.ManageRentLoss))
      menuItems.push({ caption: 'DASHBOARD.MENU.RENT_LOSS', href: 'accounting/rent-loss' });

    return new SidebarItemDefinition('DASHBOARD.ACCOUNTING_ITEM_HEADER', '', 'accounting-i', MenuSection.EconomicManagement, menuItems);
  }

  private _getSettingsMenuDefinition() {
    let menuItems: MenuDef[] = [];

    if (this.hasAdminAccess(ModuleNames.Errands)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.FAULT_NOTIFICATION_ACTION_TYPE', href: 'fault-notification/action-types' });
      menuItems.push({ caption: 'DASHBOARD.MENU.FAULT_NOTIFICATION_CATEGORY', href: 'fault-notification/categories' });
    }

    if (this.hasAdminAccess(ModuleNames.Errands) || this.hasAccess(ModuleNames.Errands, Features.ManageErrandTags))
      menuItems.push({ caption: 'DASHBOARD.MENU.TENANT_ERRAND_CATEGORY', href: 'standalone-errands/categories' });

    if (this.hasAccess(ModuleNames.Errands, Features.ManageResources)) {
      menuItems.push({ caption: 'EXECUTORGROUPS_BTN', href: 'executor-groups' });
    }

    return new SidebarItemDefinition('DASHBOARD.MENU.SETTINGS', '', 'config-i', MenuSection.TechnicalManagement, menuItems);
  }

  private _getMortgageMenuDefinition() {
    let menuItems: MenuDef[] = [];
    if (this.hasAccess(ModuleNames.Accounting, Features.AccountPlan))
      menuItems.push({ caption: 'DASHBOARD.MENU.COMPANY_MORTGAGE', href: 'company-mortgage' });

    if (this.hasAccess(ModuleNames.Accounting, Features.NominalLedger))
      menuItems.push({ caption: 'DASHBOARD.MENU.CREDIT_INSTITUTE', href: 'credit-institute' });

    return new SidebarItemDefinition('DASHBOARD.MORTGAGE_ITEM_HEADER', '', 'mortgage-i', MenuSection.EconomicManagement, menuItems);
  }

  private _getReportMenuDefinition() {
    let menuItems: MenuDef[] = [];

    if (this.hasAccess(ModuleNames.Reports, Features.ShowReportAccountBalancePerInvoice))
      menuItems.push({ caption: 'DASHBOARD.MENU.REPORT_ACCOUNT_BALANCE_PER_INVOICE', href: 'account-balance-per-invoice' });

    if (this.profileSettings.useBrf && this.hasAccess(ModuleNames.Reports, Features.ShowReportBrfInnerFundPerRentalObject)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.REPORT_INNER_FUND_PER_RENTAL_OBJECT', href: 'inner-fund-per-rental-object' });
    }

    if (this.hasAccess(ModuleNames.Reports, Features.ShowReportCheckInAndCheckOutList))
      menuItems.push({ caption: 'DASHBOARD.MENU.REPORT_CHECKIN_AND_CHECKOUT_LIST', href: 'checkin-and-checkout-list' });

    if (this.hasAccess(ModuleNames.Reports, Features.ShowReportInvoicedPerRentalObject))
      menuItems.push({ caption: 'DASHBOARD.MENU.REPORT_INVOICED_PER_RENTAL_OBJECT', href: 'invoiced-per-rental-object' });

    if (this.profileSettings.useBrf && this.hasAccess(ModuleNames.Reports, Features.ShowReportMembershipList)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.REPORT_MEMBERSHIP_LIST', href: 'membership-list' });
    }

    if (this.hasAccess(ModuleNames.Reports, Features.ShowReportMonthAnalysisAmount))
      menuItems.push({ caption: 'DASHBOARD.MENU.REPORT_MONTH_ANALYSIS_AMOUNT', href: 'month-analysis-amount' });

    if (this.hasAccess(ModuleNames.Reports, Features.ShowReportNotFullyPaidInvoice))
      menuItems.push({ caption: 'DASHBOARD.MENU.REPORT_NOT_FULLY_PAID_INVOICES', href: 'not-fully-paid-invoice' });

    if (this.hasAccess(ModuleNames.Reports, Features.ShowReportPropertyOverview))
      menuItems.push({ caption: 'DASHBOARD.MENU.REPORT_PROPERTY_LIST', href: 'property-overview' });

    if (this.hasAccess(ModuleNames.Reports, Features.ShowReportReasonablenessControl))
      menuItems.push({ caption: 'DASHBOARD.MENU.REPORT_REASONABLENESS_CONTROL', href: 'reasonableness-control' });

    if (this.hasAccess(ModuleNames.Reports, Features.ShowReportRentalObjectRentLoss))
      menuItems.push({ caption: 'DASHBOARD.MENU.REPORT_RENTAL_OBJECT_RENT_LOSS', href: 'rental-object-rent-loss' });

    if (this.hasAccess(ModuleNames.Reports, Features.ShowReportRentRoll))
      menuItems.push({ caption: 'DASHBOARD.MENU.REPORT_RENTROLL', href: 'rent-roll' });

    if (this.hasAccess(ModuleNames.Reports, Features.ShowReportRentRoll))
      menuItems.push({ caption: 'DASHBOARD.MENU.REPORT_PROPERTY_ANNUAL', href: 'property-annual-report' });

    if (this.hasAccess(ModuleNames.Reports, Features.ShowReportStaircase))
      menuItems.push({ caption: 'DASHBOARD.MENU.REPORT_STAIRCASE_LIST', href: 'staircase-report' });

    if (this.hasAccess(ModuleNames.Reports, Features.ShowReportTaxReduction))
      menuItems.push({ caption: 'DASHBOARD.MENU.REPORT_TAX_REDUCTION_LIST', href: 'tax-reduction-report' });

    if (this.hasAccess(ModuleNames.Reports, Features.ShowReportVatReport))
      menuItems.push({ caption: 'DASHBOARD.MENU.REPORT_VAT_REPORT', href: 'vat-report' });

    if (this.hasAccess(ModuleNames.Reports, Features.ShowReportVoluntaryTaxLiability))
      menuItems.push({ caption: 'DASHBOARD.MENU.REPORT_VOLUNTARY_TAX_LIABILITY', href: 'voluntary-tax-liability' });

    if (this.hasLicense(LicenseTypeKind.HomepalDashboards)) {
      menuItems.splice(0, 0, { caption: 'DASHBOARD.MENU.INSIGHTS', href: 'homepal-dashboards' });
    }

    return new SidebarItemDefinition('DASHBOARD.REPORTS_ITEM_HEADER', '', 'reports-i', MenuSection.Other, menuItems);
  }

  private _getContractMenuDefinition() {
    let menuItems: MenuDef[] = [];

    if (
      this.hasAccess(ModuleNames.Rent, Features.ManageLeaseAgreements) ||
      this.hasAccess(ModuleNames.Rent, Features.ShowLeaseAgreements)
    ) {
      menuItems.push({ caption: 'DASHBOARD.MENU.LEASE_AGREEMENT_DWELLING', href: AccountRoutes.dwellingContracts });
      menuItems.push({ caption: 'DASHBOARD.MENU.LEASE_AGREEMENT_PREMISES', href: 'premises/contracts' });
      menuItems.push({ caption: 'DASHBOARD.MENU.LEASE_AGREEMENT_PARKING', href: 'parking/contracts' });
      menuItems.push({ caption: 'DASHBOARD.MENU.LEASE_AGREEMENT_OTHER', href: 'other-rental-object/contracts' });
      menuItems.push({ caption: 'DASHBOARD.MENU.LEASE_AGREEMENT_BLOCK', href: 'block/contracts' });
    }

    if (this.hasAccess(ModuleNames.Invoicing, Features.RentInvoicing))
      menuItems.push({ caption: 'DASHBOARD.MENU.SEND_INVOICES', href: 'rent-invoicing' });

    if (this.hasAccess(ModuleNames.Rent, Features.ManageLeaseAgreements)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.VACANT_DWELLING', href: 'vacantdwelling' });
      menuItems.push({ caption: 'DASHBOARD.MENU.VACANT_PREMISES', href: 'vacantpremises' });
      menuItems.push({ caption: 'DASHBOARD.MENU.VACANT_PARKING', href: 'vacantparking' });
      menuItems.push({ caption: 'DASHBOARD.MENU.VACANT_OTHER_RENTAL_OBJECT', href: 'vacantother-rental-object' });
      menuItems.push({ caption: 'DASHBOARD.MENU.FEE_CHANGE', href: 'fee-change' });
      menuItems.push({ caption: 'DASHBOARD.MENU.RENT_APPLICATION', href: 'rent-application' });
    }

    if (this.hasAccess(ModuleNames.Rent, Features.Admin)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.APPENDIX', href: 'appendix' });
      menuItems.push({ caption: 'DASHBOARD.MENU.INDEX_CLAUSE_SETTINGS', href: 'index-clause-settings' });
    }

    return new SidebarItemDefinition('DASHBOARD.LEASE_AGREEMENT_ITEM_HEADER', '', 'contracts-i', MenuSection.EconomicManagement, menuItems);
  }

  private _getDwellingInspectionMenuDefinition() {
    return new SidebarItemDefinition(
      'DASHBOARD.DWELLING_INSPECTION_ITEM_HEADER',
      '',
      'dwelling-inspection-i',
      MenuSection.TechnicalManagement,
      [
        { caption: 'DASHBOARD.MENU.DWELLING_INSPECTION', href: 'dwelling-inspection/inspection', label: null },
        { caption: 'DASHBOARD.MENU.DWELLING_INSPECTION_TYPES', href: 'dwelling-inspection/inspection-type', label: null },
      ]
    );
  }

  private _getFaultNotificationMenuDefinition() {
    let menuItems: MenuDef[] = [];

    if (
      this.hasAccess(ModuleNames.Errands, Features.ManageFaultNotifications) ||
      this.hasAccess(ModuleNames.Errands, Features.ManageOwnFaultNotifications)
    )
      menuItems.push({ caption: 'DASHBOARD.MENU.FAULT_NOTIFICATION', href: AccountRoutes.faultNotifications });

    if (this.hasAccess(ModuleNames.Errands, Features.ManageFaultNotifications) || this.hasAccess(ModuleNames.Errands, Features.TenantList))
      menuItems.push({ caption: 'DASHBOARD.MENU.TENANT_LIST', href: 'fault-notification/tenantlist' });

    return new SidebarItemDefinition(
      'DASHBOARD.FAULT_NOTIFICATION_ITEM_HEADER',
      '',
      'fault-notifications-i',
      MenuSection.TechnicalManagement,
      menuItems
    );
  }

  private _getImdMenuDefinition(): SidebarItemDefinition {
    let menuItems: MenuDef[] = [];

    if (this.hasAccess(ModuleNames.Consumption, Features.Consumption_Pricelist_Read)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.IMD_PRICELISTS', href: 'imdpricelists' });
    }
    if (this.hasAccess(ModuleNames.Consumption, Features.Consumption_MeterModel_Read)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.IMD_METERMODELS', href: 'imdmetermodels' });
    }
    if (this.hasAccess(ModuleNames.Consumption)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.IMD_FILE_IMPORTS', href: 'imdimports' });
    }

    return new SidebarItemDefinition('DASHBOARD.CONSUMPTION_ITEM_HEADER', '', 'consumption-i', MenuSection.EconomicManagement, menuItems);
  }

  private _getInvoicingMenuDefinition(): SidebarItemDefinition {
    let menuItems: MenuDef[] = [];

    if (this.hasAccess(ModuleNames.Invoicing, Features.ShowInvoices) || this.hasAccess(ModuleNames.Invoicing, Features.ManageInvoices)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.INVOICES', href: AccountRoutes.invoices });
    }

    if (this.hasAccess(ModuleNames.Invoicing, Features.ShowPrintOrders) || this.hasAccess(ModuleNames.Invoicing, Features.ManageInvoices)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.PRINT_ORDER', href: 'print-order' });
    }

    if (this.hasAccess(ModuleNames.Invoicing, Features.ShowPayments)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.BG_PAYMENTS', href: 'bg-payments' });
    }

    if (this.hasAccess(ModuleNames.Invoicing, Features.ShowIncorrectPayments) || this.hasAccess(ModuleNames.Invoicing, Features.ManageIncorrectPayments))
      menuItems.push({ caption: 'DASHBOARD.MENU.INCORRECT_PAYMENT', href: 'incorrect-payments' });

    if (this.hasAccess(ModuleNames.Invoicing, Features.ShowBankTransactionImports) || this.hasAccess(ModuleNames.Invoicing, Features.ManageIncorrectPayments))
      menuItems.push({ caption: 'DASHBOARD.MENU.BANK_IMPORT_TRANSACTIONS', href: AccountRoutes.bankTransactionImports });

    if (this.hasAccess(ModuleNames.Invoicing, Features.ShowContactBalanceTransactions) || this.hasAccess(ModuleNames.Invoicing, Features.ManageIncorrectPayments))
      menuItems.push({ caption: 'DASHBOARD.MENU.CONTACT_BALANCE_TRANSACTION', href: 'contact-balance-transactions' });

    if (this.hasAccess(ModuleNames.Invoicing, Features.ShowInvoiceReminders) || this.hasAccess(ModuleNames.Invoicing, Features.ManageInvoices)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.INVOICE_REMINDERS', href: 'invoice-reminders' });
    }

    if (this.hasAccess(ModuleNames.Invoicing, Features.ShowAmortizationPlans) || this.hasAccess(ModuleNames.Invoicing, Features.ManageInvoices)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.AMORTIZATION_PLAN', href: 'amortization-plan' });
    }

    if (this.hasAccess(ModuleNames.Invoicing, Features.ShowAmortizationPlanPaymentNotices) || this.hasAccess(ModuleNames.Invoicing, Features.ManageInvoices)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.AMORTIZATION_PLAN_PAYMENT_NOTICES', href: 'amortization-plan-payment-notices' });
    }

    if (this.hasAccess(ModuleNames.Invoicing, Features.ShowDebtCollectionCases) || this.hasAccess(ModuleNames.Invoicing, Features.ManageDebtCollection)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.DEBT_COLLECTION', href: 'debt-collection' });
    }

    if (this.hasAccess(ModuleNames.Invoicing, Features.ShowPayments)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.DIRECT_DEBIT', href: 'direct-debit' });
      menuItems.push({ caption: 'DASHBOARD.MENU.DIRECT_DEBIT_LOG', href: 'direct-debit-log' });
    }

    if (this.profileSettings.useInvoiceRowGroup && (this.hasAccess(ModuleNames.Invoicing, Features.ShowInvoiceRowGroups) || this.hasAccess(ModuleNames.Invoicing, Features.InvoiceRowGroup))) {
      menuItems.push({ caption: 'DASHBOARD.MENU.INVOICE_ROW_GROUP', href: 'invoice-row-group' });
    }

    if (this.hasAccess(ModuleNames.Invoicing, Features.ShowPayments)) {
      // TODO-B2C: Feature?
      // TODO-B2C: unhide when ready
      //menuItems.push({ caption: 'DASHBOARD.MENU.B2C_SUBS', href: 'b2c-subscriptions' });
    }

    return new SidebarItemDefinition('DASHBOARD.INVOICE_ITEM_HEADER', '', 'invoices-i', MenuSection.EconomicManagement, menuItems);
  }

  private _getMessagesMenuDefinition(): SidebarItemDefinition {
    let menuItems: MenuDef[] = [];

    if (this.hasAccess(ModuleNames.Messages, Features.ManageMail)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.SEND_TENANT_MAIL', href: 'mail/recipients' });
      menuItems.push({ caption: 'DASHBOARD.MENU.MAIL', href: 'mail/sent' });
    }

    if (this.hasAccess(ModuleNames.Messages, Features.ManageEmail)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.SEND_TENANT_EMAIL', href: 'email/recipients' });
      menuItems.push({ caption: 'DASHBOARD.MENU.EMAIL', href: 'email/sent' });
    }

    if (this.hasAccess(ModuleNames.Messages, Features.ManageSms)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.SEND_TENANT_SMS', href: 'sms/recipients' });
      menuItems.push({ caption: 'DASHBOARD.MENU.SMS', href: 'sms/sent' });
    }

    if (this.hasAccess(ModuleNames.Messages, Features.ManageESignatures)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.ESIGNATURE_ERRANDS', href: 'esignature-errand' });
    }

    if (this.hasAccess(ModuleNames.Messages, Features.ManageTenantPagesInformation)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.POSTS', href: 'posts' });
    }

    return new SidebarItemDefinition('DASHBOARD.MESSAGE_ITEM_HEADER', '', 'messages-i', MenuSection.Base, menuItems);
  }

  private _getPropertiesMenuDefinition(): SidebarItemDefinition {
    let menuItems: MenuDef[] = [];

    if (
      this.hasAdminAccess(ModuleNames.Properties) ||
      this.hasAccess(ModuleNames.Properties, Features.ShowCompany) ||
      this.hasAccess(ModuleNames.Properties, Features.EditCompany)
    )
      menuItems.push({ caption: 'DASHBOARD.MENU.COMPANY', href: 'my-property/company' });

    if (
      this.hasAdminAccess(ModuleNames.Properties) ||
      this.hasAccess(ModuleNames.Properties, Features.ShowProperty) ||
      this.hasAccess(ModuleNames.Properties, Features.EditProperty)
    )
      menuItems.push({ caption: 'DASHBOARD.MENU.PROPERTY', href: 'my-property/property' });

    if (
      this.hasAdminAccess(ModuleNames.Properties) ||
      this.hasAccess(ModuleNames.Properties, Features.ShowBuilding) ||
      this.hasAccess(ModuleNames.Properties, Features.EditBuilding)
    )
      menuItems.push({ caption: 'DASHBOARD.MENU.BUILDING', href: 'my-property/building' });

    if (
      this.hasAdminAccess(ModuleNames.Properties) ||
      this.hasAccess(ModuleNames.Properties, Features.ShowDwelling) ||
      this.hasAccess(ModuleNames.Properties, Features.EditDwelling)
    )
      menuItems.push({ caption: 'DASHBOARD.MENU.DWELLING', href: 'my-property/dwelling' });

    if (
      this.hasAdminAccess(ModuleNames.Properties) ||
      this.hasAccess(ModuleNames.Properties, Features.ShowPremises) ||
      this.hasAccess(ModuleNames.Properties, Features.EditPremises)
    )
      menuItems.push({ caption: 'DASHBOARD.MENU.PREMISES', href: 'my-property/premises' });

    if (
      this.hasAdminAccess(ModuleNames.Properties) ||
      this.hasAccess(ModuleNames.Properties, Features.ShowParking) ||
      this.hasAccess(ModuleNames.Properties, Features.EditParking)
    )
      menuItems.push({ caption: 'DASHBOARD.MENU.PARKING', href: 'my-property/parking' });

    if (
      this.hasAdminAccess(ModuleNames.Properties) ||
      this.hasAccess(ModuleNames.Properties, Features.ShowOtherRentalObject) ||
      this.hasAccess(ModuleNames.Properties, Features.EditOtherRentalObject)
    )
      menuItems.push({ caption: 'DASHBOARD.MENU.OTHER_RENTAL_OBJECT', href: 'my-property/other-rental-object' });

    if (
      this.hasAdminAccess(ModuleNames.Properties) ||
      this.hasAccess(ModuleNames.Properties, Features.ShowRentalObjectKeys) ||
      this.hasAccess(ModuleNames.Properties, Features.EditRentalObjectKeys)
    )
      menuItems.push({ caption: 'DASHBOARD.MENU.KEYS', href: 'my-property/rental-object-keys' });

    if (this.hasAdminAccess(ModuleNames.Properties)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.RENTAL_OBJECT_TYPE', href: 'my-property/rental-object-type' });
      menuItems.push({ caption: 'DASHBOARD.MENU.BUILDING_SPACE_TYPE', href: 'my-property/building-space-type' });
    }

    if (this.hasAccess(ModuleNames.Properties, Features.EditLettingFeatures))
      menuItems.push({ caption: 'DASHBOARD.MENU.LETTING_FEATURES', href: 'my-property/letting-feature' });

    if (this.hasAdminAccess(ModuleNames.Properties)) {
      menuItems.push({ caption: 'DASHBOARD.MENU.CUSTOMPROPERTIES', href: 'custom-property' });
      menuItems.push({ caption: 'DASHBOARD.MENU.COMPONENT_CATEGORY', href: 'component-category' });
      menuItems.push({ caption: 'DASHBOARD.MENU.KEYTYPES', href: 'keytypes' });
    }

    return new SidebarItemDefinition('DASHBOARD.MY_PROPERTY_ITEM_HEADER', '', 'property-i', MenuSection.Other, menuItems);
  }

  private _getRoundplanningMenuDefinition(): SidebarItemDefinition {
    let menuItems: MenuDef[] = [];

    if (this.hasAdminAccess(ModuleNames.Errands)) {
      // if (this.hasAccess(ModuleNames.RoundPlanning, Features.ShowRoundPlanning))
      menuItems.push({ caption: 'DASHBOARD.MENU.ROUNDPLANNING', href: 'rounding/round-planning' });

      // if (this.hasAccess(ModuleNames.RoundPlanning, Features.ShowChecklist))
      menuItems.push({ caption: 'DASHBOARD.MENU.CHECKLISTS', href: 'rounding/checklist' });
    }

    if (
      this.hasAccess(ModuleNames.Errands, Features.ManageRoundingErrands) ||
      this.hasAccess(ModuleNames.Errands, Features.ManageOwnRoundingErrands)
    ) {
      menuItems.push({ caption: 'DASHBOARD.MENU.ROUNDS', href: 'rounding/round' });
    }

    return new SidebarItemDefinition('DASHBOARD.ROUNDPLANNING_HEADER', '', 'roundplanning-i', MenuSection.TechnicalManagement, menuItems);
  }

  private _getAuthorityInspectionMenuDefinition(): SidebarItemDefinition {
    let menuItems: MenuDef[] = [];

    if (this.hasAccess(ModuleNames.AuthorityInspection, Features.ManageAuthorityInspection)) {
      menuItems.push({ caption: 'AUTHORITY_INSPECTION.INSPECTIONS', href: 'authority-inspection/inspection' });
      menuItems.push({ caption: 'AUTHORITY_INSPECTION.INSPECTION_TYPE.INSPECTION_TYPES', href: 'authority-inspection/inspection-type' });
    }

    return new SidebarItemDefinition(
      'AUTHORITY_INSPECTION.HEADER',
      '',
      'authorityinspection-i',
      MenuSection.TechnicalManagement,
      menuItems
    );
  }
}
